module.exports = __webpack_public_path__ + "static/media/marble-extraction.366ea220.jpg";